import React from 'react';
import {Spin, Tree, message,Select} from 'antd';
import MyAutoComplete from './MyAutoComplete';
const TreeNode = Tree.TreeNode;
import  './index.scss'
import {WWMethods,WWUtils} from "@/tools/index";
const Option = Select.Option;
export default class SimpleTreeUpdate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            userData: null,
            organizationId: this.props.organizationId? this.props.organizationId : localStorage.getItem("organizationId"),
            expandedKeys: [this.props.organizationId ? String(this.props.organizationId) : localStorage.getItem("organizationId")],
            defaultSelectedKeys: [this.props.organizationId ? String(this.props.organizationId) : localStorage.getItem("organizationId")],
            autoExpandParent: true,
            selectedKeys: [this.props.organizationId ? String(this.props.organizationId) :this.props.disRootSelected?this.props.organizationId: localStorage.getItem("organizationId")],
            showTree: 'none',
            searchUrl:WWMethods.getApiUrl("searchUrlBrief")+"?length=5&content=",
            treeVisible:false,
            width:"90%",
            popVisible:false,
            parentClass:this.props.parentClass,
            showRootName:this.props.showRootName,
            showSearchInput:true,
            autoSearch:true,//是否显示搜索框
            treeUrl:WWMethods.getApiUrl("loadTreeUrl"),
            disLazyLoad:false,//懒加载
            getAllParentAccountUrl:WWMethods.getApiUrl("allParents"),
            deepToRootUrl:WWMethods.getApiUrl("expandTree"),
            isTallTree:this.props.isTallTree || false,//查询时会带parentID
            organizationName:"",
            selectClass:"disabledSelect",
            showSelect:this.props.showSelect || false
        };
        this.onSelect = this.onSelect.bind(this);
        this.onExpand = this.onExpand.bind(this);
        this.getNodeTitle = this.getNodeTitle.bind(this);
        this.loadCustomerTree = this.loadCustomerTree.bind(this);
        this.onLoadData = this.onLoadData.bind(this);
        this.loop = this.loop.bind(this);
        this.setSelectedKeys = this.setSelectedKeys.bind(this);
        this.setTreeShow = this.setTreeShow.bind(this);
        this.setValue = this.setValue.bind(this);
        this.sendAccountId = this.sendAccountId.bind(this);
        this.hideTree = this.hideTree.bind(this);
        this.clearInput = this.clearInput.bind(this);
        this.selectName = this.selectName.bind(this);
        this.deepToRoot = this.deepToRoot.bind(this);
        this.getAllParentAccount = this.getAllParentAccount.bind(this);
        this.togglePopVisible = this.togglePopVisible.bind(this);
        this.updateDatas_simple = this.updateDatas_simple.bind(this);
        this.refreshSetId = this.refreshSetId.bind(this);
        this.onBodyClick = this.onBodyClick.bind(this);
    }

    componentWillMount() {

    }

    componentDidMount() {
        if (this.props.selectedKeys) {
            this.setSelectedKeys(this.props.selectedKeys);
        }
        if (this.props.ownerName) {
            this.refs.selectInput.setValue(this.props.ownerName);
        }
        document.body.addEventListener("click", this.onBodyClick);
        this.loadCustomerTree(this.state.organizationId)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.selectedKeys !== this.props.selectedKeys) {
            this.setSelectedKeys(nextProps.selectedKeys);
        }
        if (nextProps.ownerName !== this.props.ownerName) {
            this.refs.selectInput.setValue(nextProps.ownerName);
        }
        if (nextProps.searchUrl != this.props.searchUrl) {
            this.setState({
                searchUrl:nextProps.searchUrl
            })
        }
        if (nextProps.treeVisible != this.props.treeVisible) {
            this.setState({
                treeVisible:nextProps.treeVisible
            })
        }
        if (nextProps.popVisible != this.props.popVisible) {
            this.setState({
                popVisible:nextProps.popVisible
            })
        }
        if (nextProps.parentClass != this.props.parentClass) {
            this.setState({
                parentClass:nextProps.parentClass
            })
        }
        if (nextProps.showRootName != this.props.showRootName) {
            this.setState({
                showRootName:nextProps.showRootName
            })
        }
    }

    componentWillUnmount() {
        document.body.removeEventListener('click', this.onBodyClick);
    }

    //切换弹框树的显示
    togglePopVisible(data){
        this.setState({
            popVisible:data
        })
    }



    //更新树初始化信息
    updateDatas_simple(data){
        const {searchUrl,organizationName,showSelect,expandedKeys,selectClass,autoSearch,disLazyLoad,treeUrl,getAllParentAccountUrl,deepToRootUrl,isTallTree} = this.state;
        this.setState({
            treeVisible:data.treeVisible,
            popVisible:data.popVisible,
            searchUrl:data.searchUrl?data.searchUrl:searchUrl,
            autoSearch:data.autoSearch?false:autoSearch,
            treeUrl:data.treeUrl?data.treeUrl:treeUrl,
            disLazyLoad:data.disLazyLoad?data.disLazyLoad:disLazyLoad,
            getAllParentAccountUrl:data.getAllParentAccountUrl?data.getAllParentAccountUrl:getAllParentAccountUrl,
            deepToRootUrl:data.deepToRootUrl?data.deepToRootUrl:deepToRootUrl,//定位到某个节点的URL
            isTallTree:data.isTallTree?data.isTallTree:isTallTree,//显示整颗树，不根据登录用户
            organizationName:data.hasOwnProperty("organizationName")?data.organizationName:organizationName,
            selectClass:data.selectClass?data.selectClass:selectClass,//下拉框样式
            expandedKeys:data.expandedKeys?data.expandedKeys:expandedKeys,//设置展开节点
            showSelect:data.showSelect?data.showSelect:showSelect,//是否显示下拉框
            selectedKeys:data.hasOwnProperty("selectedKeys")?data.selectedKeys:[],
            organizationId:data.hasOwnProperty("organizationId")?data.organizationId:"",
            defaultSelectedKeys:data.hasOwnProperty("defaultSelectedKeys")?data.defaultSelectedKeys:[],
        },()=>{
            this.loadCustomerTree(localStorage.getItem("organizationId"));
        });
    }

    refreshSetId(data){
        this.setState({
            refresh_f:data.refresh_f,
            organizationId:data.organizationId
        })
    }
    //获取当前节点所有的父节点，并定位到节点
    getAllParentAccount(organizationId) {
        const {getAllParentAccountUrl} = this.state;
        let url = `${getAllParentAccountUrl}${organizationId}`;
        let that = this;
        WWUtils.fetch(url,'GET',(data)=>{
            if (data && data.resultStatusBean && data.resultStatusBean.code === 0 || data && data.code === 0) {
                if (data.data instanceof Array) {
                    let expandedKeys = [];
                    data.data.map(function (item) {
                        expandedKeys.push(String(item.organizationId));
                    });
                    that.deepToRoot(expandedKeys, organizationId);

                }
            }else if(data && data.resultBean && data.resultBean.code === 40010){
                message.error(data.message || data.resultBean.result)
            }
        })
    }
    //定位到节点
    deepToRoot(expandedKeys,organizationId){
        const {deepToRootUrl} = this.state;
        let url = deepToRootUrl+organizationId;
        let that = this;
        WWUtils.fetch(url,'GET',(data)=>{
            if (data && data.resultBean && data.resultBean.code === 0 || data && data.code === 0) {
                setTimeout(()=>{
                    that.setState({
                        userData:data.data,
                        expandedKeys,
                        selectedKeys: [organizationId.toString()],
                        autoExpandParent: true,
                        organizationId:organizationId
                    },()=>{
                        //客户节点被选中，执行滚动操作
                        let pClass = that.props.parentClass;
                        let pNode = $("."+pClass)
                        let container = pNode.find('#components-tree-demo-customized-icon'),
                            scrollTo = pNode.find('#components-tree-demo-customized-icon span.ant-tree-node-selected');
                        if (scrollTo.offset()) {
                            container.animate({
                                scrollTop: scrollTo.offset().top - container.offset().top + container.scrollTop()-200
                            }, 200);
                        }
                    });
                },500)


            } else {
                message.warning(data.message || data.resultBean.result);
            }
        });
    }
    //展开/收起节点时触发
    onExpand(expandedKeys, e) {
        if (e.expanded) {
            this.setState({
                expandedKeys: expandedKeys,
                autoExpandParent: false,
            });
        } else {
            if (expandedKeys instanceof Array) {
                let _expandedKeys = expandedKeys.filter(function (item) {
                    return item != e.node.props.eventKey;
                });
                this.setState({
                    expandedKeys: _expandedKeys,
                    autoExpandParent: false,
                });
            }
        }
    }
    //异步加载客户节点数据
    loadCustomerTree(treeNodeKey, forceRefresh, treeNodeKeys, index, reflsh) {
        if (!forceRefresh) {
            forceRefresh = false;
        }
        let that = this;

        //存儲節點的key值
        if (treeNodeKey) {
            window.treeNodeKey = treeNodeKey;
        }
        const {organizationId, status,treeUrl,isTallTree} = this.state;
        let url = treeUrl;
        if (treeNodeKeys instanceof Array) {
            if (index == treeNodeKeys.length) {
                return;
            }
            treeNodeKey = treeNodeKeys[index];
        }

        if(!isTallTree){//查询带parentID
            if (treeNodeKey) {
                url = url + "?parentId=" + treeNodeKey;
            } else {
                if (organizationId) {
                    url = url + "?parentId=" + organizationId;
                }
            }
            if (status !== undefined) {
                url = url + "&status=" + status;
            }
        }
        that.setState({
            loading: true
        });
        WWUtils.fetch(WWUtils.getNoCacheURL(url),"GET",(data)=>{
            if (data.resultBean && data.resultBean.code === 0 || data && data.code === 0) {
                const getUserData = (initUserData, data) => {
                    if (!initUserData) {
                        return data;
                    } else {
                        replaceNodeData(initUserData);
                    }

                    function replaceNodeData(initUserData) {
                        if (initUserData.organizationId === data.organizationId) {
                            let hasChild = false;
                            if (initUserData.subOrganizationList instanceof Array) {
                                initUserData.subOrganizationList.map(function (item) {
                                    if (item.subOrganizationList instanceof Array) {
                                        hasChild = true;
                                        return false;
                                    }
                                });
                            }
                            if (forceRefresh) {
                                initUserData.subOrganizationList = data.subOrganizationList;
                            } else {
                                if (!hasChild) {
                                    initUserData.subOrganizationList = data.subOrganizationList;
                                }
                            }
                        } else {
                            if (initUserData instanceof Array) {
                                initUserData.map(function (item) {
                                    replaceNodeData(item);
                                })
                            } else if (initUserData.subOrganizationList instanceof Array) {
                                initUserData.subOrganizationList.map(function (item) {
                                    replaceNodeData(item);
                                })
                            }
                        }
                    }

                    return initUserData;
                };
                let userData = data.data;
                let obj_data ={
                    autoExpandParent:true,
                };
                if(userData.subOrganizationList instanceof  Array &&!userData.organizationId){
                    let cur_orgId = userData.subOrganizationList[0].organizationId;
                    //默认不选中根节点
                   ! (that.props.disRootSelected)? obj_data.selectedKeys =[cur_orgId.toString()]:""
                    obj_data.organizationId = cur_orgId.toString();
                    if (that.props.handleChange) {
                        let nodeName = userData.subOrganizationList[0].name;
                        obj_data.organizationName = nodeName;
                        if (nodeName) {
                            that.props.handleChange(cur_orgId.toString(), nodeName);
                        }

                    }
                }else if(isTallTree){//部门管理不同用户登录显示整棵树，不是部分树，并且默认选中第一个节点并展开
                    ! (that.props.disRootSelected)?obj_data.selectedKeys =[userData.organizationId.toString()]:null;
                    obj_data.organizationId = userData.organizationId.toString();
                    obj_data.expandedKeys = [userData.organizationId.toString()];
                }else{
                    userData = getUserData(that.state.userData, data.data);
                }
                obj_data.userData = userData;
                obj_data.isTallTree = false;
                if(that.state.showRootName){
                    obj_data.organizationName = userData.name;
                }
                that.setState(obj_data,()=>{
                    if(that.state.showRootName ) {
                        that.refs.selectInput.setValue(that.state.userData.name);
                    }
                });

                //递归加载树节点
                if (treeNodeKeys instanceof Array) {
                    that.loadCustomerTree(null, null, treeNodeKeys, ++index);
                }
            }else{
                message.warning(data.message || data.resultBean.result);
            }
        })
    }
    //设置选中节点
    setSelectedKeys(key, nodeName) {
        this.setState({
            selectedKeys: [key],
            organizationId:key,
            organizationName:nodeName
        }, () => {
            if (this.props.handleChange) {
                if (nodeName) {
                    this.props.handleChange(key, nodeName);
                }
            }
        })
    }

    //选择客户树节点
    onSelect(info, e) {
        let organizationId = info[0];
        let nodeName = e.node.props.nodeName;
        let nodeKey = e.node.props.eventKey;
        let storageAccountId = localStorage.getItem("organizationId");
        const {expandedKeys,disLazyLoad,userData} = this.state;
        window.init_flag = true;
        if (organizationId) {
            this.setSelectedKeys(organizationId, nodeName);
            if (e.node.props.expanded) {
                if (e.node.props.eventKey !== storageAccountId) {
                    let _expandedKeys = expandedKeys.filter(function (item) {
                        return item !== e.node.props.eventKey
                    });
                    _expandedKeys.push(storageAccountId);
                    this.setState({
                        expandedKeys: _expandedKeys,
                        autoExpandParent: false,
                        showRootName:false
                    });
                }
            } else {
                //选择节点同时展开节点
                let _expandKeys = expandedKeys;
                if(_expandKeys.indexOf(organizationId)== -1){
                    _expandKeys.push(organizationId.toString());
                }
                if(_expandKeys.indexOf(storageAccountId)== -1){
                    _expandKeys.push(storageAccountId);
                }

                this.setState({
                    expandedKeys: _expandKeys,
                    autoExpandParent: true,
                    showRootName:false
                }, () => {
                    if(!e.node.props.isLeaf && !disLazyLoad){
                        this.loadCustomerTree(organizationId);
                    }
                });
            }
        } else {
            if (e.node.props.expanded) {
                if (e.node.props.eventKey !== storageAccountId) {
                    let _expandedKeys = expandedKeys.filter(function (item) {
                        return item !== e.node.props.eventKey
                    });
                    _expandedKeys.push(storageAccountId);
                    this.setState({
                        expandedKeys: _expandedKeys,
                        autoExpandParent: false,
                        showRootName:false
                    });
                }
            } else {
                let _expandKeys = expandedKeys;
                if(_expandKeys.indexOf(e.node.props.eventKey) == -1){
                    _expandKeys.push(e.node.props.eventKey);
                }
                this.setState({
                    expandedKeys: _expandKeys,
                    autoExpandParent: false,
                    showRootName:false
                });
            }
        }
        if(this.props.hideDeepTree){
            this.props.hideDeepTree();
        }

    }

    //异步加载树节点
    onLoadData(treeNode) {
        let that = this;
        const {disLazyLoad} = this.state;
        return new Promise((resolve) => {
            if(!disLazyLoad){
                that.loadCustomerTree(treeNode.props.eventKey);
            }

            resolve();
        });
    }


    getNodeTitle(nodeData) {
        return nodeData.name;
    }

    loop(userData) {
        const mapper = (item) => {
            if (item.subOrganizationList instanceof Array) {
                return this.loop(item)
            } else {
                return (
                    <TreeNode nodeName={item.name} title={<span>{this.getNodeTitle(item)}</span>} key={item.organizationId} isLeaf={item.isLeaf == 0}/>
                )
            }

        };
        if (userData) {
            if (userData instanceof Array) {
                return userData.map(mapper)
            } else if (userData.subOrganizationList instanceof Array) {
                if(userData.organizationId){
                    return (
                        <TreeNode nodeName={userData.name} title={<span>{this.getNodeTitle(userData)}</span>} key={userData.organizationId}
                                  isLeaf={userData.isLeaf == 0}>
                            {userData.subOrganizationList.map(mapper)}
                        </TreeNode>)
                }else{
                   return  userData.subOrganizationList.map(mapper)
                }

            } else {
                return ( <TreeNode nodeName={userData.name}  title={<span>{this.getNodeTitle(userData)}</span>}
                                   key={userData.organizationId} isLeaf={userData.isLeaf == 0}/>)
            }
        }
        return null;
    }
    selectName(organizationId,value){
        if(this.props.selectName instanceof Function) {
            this.props.selectName(organizationId,value);
        }
    }
    //是否显示客户树
    setTreeShow(data) {
        let that = this;
        setTimeout(()=>{
            //客户节点被选中，执行滚动操作
            let pClass = that.props.parentClass;
            let container =  $("."+pClass).find('#components-tree-demo-customized-icon'),
                scrollTo =  $("."+pClass).find('#components-tree-demo-customized-icon span.ant-tree-node-selected');
            if (scrollTo.offset()) {
                container.animate({
                    scrollTop: scrollTo.offset().top - container.offset().top + container.scrollTop()-150
                }, 0);
            }
        },500);
        if(this.props.disabled){
            return;
        }
        this.togglePopVisible(true);
    }


    setValue(data) {
        this.refs.selectInput.setValue(data);
    }

    //当匹配到第一个项的时候传id
    sendAccountId(id, accountValue) {
        if (this.props.sendAccountId) {
            this.props.sendAccountId(id, accountValue);
        }
    }
    hideTree() {
        this.setState({
            showTree: 'none'
        })
    }
    clearInput(){
        this.refs.selectInput.setState({
            value:""
        })
    }
    onBodyClick(e){
        if(!this.props.disHide && this.state.parentClass && !this.state.treeVisible && !this.state.disabled){
            let x = e.pageX;
            let y = e.pageY;
            let pClass = this.state.parentClass;
            let directShowTree = this.state.directShowTree;
            let div = directShowTree?$("."+pClass).find(".simpleTree"):$("."+pClass).find(".popTree");//获取你想要的DIV
            let searchDiv = $("."+pClass).eq(0);//搜索框
            // console.log(div)
            // console.log(searchDiv)
            if(div.offset() && searchDiv.offset()){

                let y1 = div.offset().top;  //div上面两个的点的y值
                let y2 = y1 + div.height();//div下面两个点的y值
                let x1 = div.offset().left;  //div左边两个的点的x值
                let x2 = x1 + div.width();  //div右边两个点的x的值

                let y3 = searchDiv.offset().top;  //div上面两个的点的y值
                let y4 = y3 + searchDiv.height();//div下面两个点的y值
                let x3 = searchDiv.offset().left;  //div左边两个的点的x值
                let x4 = x3 + searchDiv.width();  //div右边两个点的x的值
                // console.log(x>=x1 && x<=x2 &&  y>=y1 && y<=y2)
                // console.log(x>=x3 && x<=x4 && y>=y3 && y<=y4)
                if( (x>=x1 && x<=x2 &&  y>=y1 && y<=y2) || (x>=x3 && x<=x4 && y>=y3 && y<=y4)){
                    // console.log('鼠标在该DIV中');
                }else{
                    // console.log('鼠标在该DIV外');
                    this.togglePopVisible(false);

                }
            }

        }
    }
    render() {
        const {treeVisible,popVisible,searchUrl,width,autoSearch,organizationName,selectClass,showSelect} = this.state;
        const {userData, expandedKeys, defaultSelectedKeys, autoExpandParent, selectedKeys} = this.state;
        const {disabled,selectWidth,directShowTree,allowClearSelect} = this.props;
        return (
            <div className="treeContainer">
                <Select placeholder={Strings.selectorg || "请选择门店"}
                        dropdownStyle={{display: 'none'}}
                        className={selectClass} value={organizationName}
                        style={{display:showSelect?"block":"none",width:selectWidth?selectWidth:"150px"}}
                        allowClear={allowClearSelect?true:false}
                        onClick={()=>{
                            if(this.state.popVisible){
                                this.togglePopVisible(false);
                            }else{
                                this.setState({
                                    popVisible:true
                                })
                            }
                        }}
                        onChange={(value)=>{
                            if(!value){
                                this.setState({
                                    organizationName:Strings.selectorg || "请选择门店",
                                    selectedKeys:[],
                                    popVisible:true
                                },()=>{
                                    if(this.props.handleChange){
                                        this.props.handleChange("","")
                                    }
                                    this.setValue("");
                                })
                            }
                        }}
                />

                <div className={directShowTree?"simpleTree":"popTree"} style={{display:popVisible?"block":"none"}}>
                    <div style={{width:"100%",zIndex:10,background:"#fff",display:popVisible?"flex":"none",flex:"1",flexDirection:"column",position:'relative'}} >
                        <div style={{display:(popVisible && autoSearch)?"block":"none"}}>
                            <MyAutoComplete width={width} pathType={this.props.pathType} onSelect={this.onSelect}
                                            positionCustomerNode={(expandedKeys, organizationId)=>
                                            {this.deepToRoot(expandedKeys, organizationId)}}
                                            showTree={this.setTreeShow}
                                            setTreeShow={this.setTreeShow}
                                            sendAccountId={this.sendAccountId}
                                            searchUrl={searchUrl}
                                            disabled={disabled}
                                            selectName={(id,name)=>{
                                                this.setState({
                                                    organizationName:name,
                                                    popVisible:true
                                                })
                                            }}
                                            ref="selectInput" margins={this.props.margins}/>
                        </div>
                        <Spin spinning={false} size="small" >
                            <div className={treeVisible?"treeAutoDiv":"treeDiv"}
                                 id="components-tree-demo-customized-icon" style={{display:treeVisible?"block":popVisible?"block":"none",borderTop:autoSearch?"":"0px"}}>
                                <Tree loadData={this.onLoadData}
                                      onSelect={this.onSelect}
                                      onExpand={this.onExpand}
                                      expandedKeys={expandedKeys}
                                      selectedKeys={selectedKeys}
                                      showLine={JSON.stringify(userData).indexOf("type")>-1?false:true}
                                      autoExpandParent={autoExpandParent}
                                      defaultSelectedKeys={defaultSelectedKeys}
                                      className={JSON.stringify(userData).indexOf("type")>-1?"customer_tree salePersonTree":"customer_tree"}>
                                    {this.loop(userData)}
                                </Tree>
                            </div>
                        </Spin>
                    </div>
					{this.props.showClear?
                        <a style={{height:25,lineHeight:'25px',paddingLeft:20,borderTop:"1px solid #eee",
                        position:'absolute',bottom:'8px',zIndex:'10',width:'95%',background:'#fff'}}
                             onClick={()=>{
                                 this.setState({
                                     organizationName:Strings.selectorg ||'请选择门店',
                                     organizationId:'',
                                     selectedKeys:[],
                                 },()=>{
                                     this.refs.selectInput.setState({value:''})
                                     if(this.props.handleChange){
                                         this.props.handleChange("","")
                                     }
                                 })
                             }}>
                        清除选中门店</a>:null}
                </div>
            </div>

        )
    }
}

